import { SlotGameType1_21 } from '../SlotGameType1_21';

export class LavaLand21 extends SlotGameType1_21
{
}
